import React from 'react';
import { formatDate } from '../../helpers/FormatHelper';
import NumberInput from '../shared/NumberInput';
import DynamicSelect from '../shared/DynamicSelect';
import DatePicker from '../shared/DatePicker';
import DynamicSearchSelect from '../shared/DynamicSearchSelect';
import { searchCustomerByIdNameMin } from '../../networking/NetworkingCustomers';
import { getStyle, regularInputClass, regularSelectClass } from '../../styles/styles';
var style = getStyle();

export default class OrderForm extends React.Component {    
    state = {        
        criteria: {
            orderNroFrom: '',
            CustomerIDName: '',
            valueDateFrom: '',
            valueDateTo: '',
            status: '',
            lockedside: '',
            CustomerID: '',
            customerList: [],
            statusList: [],
            lockedsideList: []
        }
    }
    
    componentDidMount() {
        this.loadOrderStatus();
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.lockedSide !== this.props.lockedSide) ||
            (prevProps.valueDateFrom !== this.props.valueDateFrom) ||
            (prevProps.valueDateTo !== this.props.valueDateTo)
        ){
            this.setState({
                criteria: {
                    ...this.state.criteria,
                    orderNroFrom: '',
                    CustomerID: '',
                    valueDateFrom: this.props.valueDateFrom,
                    valueDateTo: this.props.valueDateTo,
                    status: '',
                    lockedside: '',
                    CustomerIDName: ''
                }
            });
        }
    }

    loadOrderStatus(){
        let statusList=[
            {value:'Pending',name:'Pending'},
            {value:'Accepted',name:'Accepted'}
        ]
        let lockedsideList=[
            {value:'Buy',name:'Buy'},
            {value:'Sell',name:'Sell'}
        ]
        this.setState({ criteria: { ...this.state.criteria, statusList: statusList, lockedsideList: lockedsideList } });
    }
    
    searchCustomer(query) {
        console.group("searchCustomer");
        console.log(query);
        console.groupEnd();
        searchCustomerByIdNameMin(query).then(
            (response) => {
                if (response.customers !== undefined) {
                    for (var i = 0; i < response.customers.length; i++) {
                        response.customers[i].value = response.customers[i].CustomerID;
                        response.customers[i].name = response.customers[i].CustomerIDName;
                    }
                    this.setState({ criteria: { ...this.state.criteria, customerList: response.customers} });
                }
            }
        )
    }

    handleUpdateOrderNroFrom(event) {
        this.setState({ criteria: { ...this.state.criteria, orderNroFrom: event.target.value } });
    }
    handleUpdateCustomerIDName(value) {
        if (value.value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: value.name !== 'select' ? value.name : '', CustomerID: value.value !== 'select' ? value.value : '' } });
        }else if (value.value === undefined){
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: '', CustomerID: '' } });
        }
    }
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchCriteriaClick();
        }
    };
    handleUpdateStatus(value) {
        if (value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, status: value.value !== 'select' ? value.value : '-1' } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, status: '', } });
        }
    }
    handleUpdateLockedSide(value) {
        if (value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, lockedside: value.value !== 'select' ? value.value : '-1' } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, lockedside: '', } });
        }
    }
    handleUpdateValueDateFrom(date) {
        if (date !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, valueDateFrom: formatDate(date) } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, valueDateFrom: '' } });
        }
    }
    handleUpdateValueDateTo(date) {
        if (date !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, valueDateTo: formatDate(date) } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, valueDateTo: '' } });
        }
    }
    
    //CLEAR CRITERIA
    handleClearCriteriaClick(event) {
        event.preventDefault();
        this.setState({
            criteria: {
                ...this.state.criteria,
                orderNroFrom: '',
                CustomerID: '',
                valueDateFrom: '',
                valueDateTo: '',
                status: '',
                lockedside: '',
                CustomerIDName: '',
            }
        });
        this.props.clearGrid();
    }

    //SEARCH CRITERIA
    handleSearchCriteriaClick(event) {
        var objFilter = {
            BNOrderNo: this.state.criteria.orderNroFrom === '' ? null : this.state.criteria.orderNroFrom,
            CustomerID: this.state.criteria.CustomerID,
            //CustomerName: this.state.criteria.CustomerIDName === '' ? null : this.state.criteria.CustomerIDName,
            OrderDateFrom: this.state.criteria.valueDateFrom === '' ? null : this.state.criteria.valueDateFrom,
            OrderDateTo: this.state.criteria.valueDateTo === '' ? null : this.state.criteria.valueDateTo,
            OrderStatus: this.state.criteria.status === '' ? null : this.state.criteria.status,
            LockedSide: this.state.criteria.lockedside === '' ? null : this.state.criteria.lockedside
        };
        this.props.searchDealsGrid(objFilter);
    }
    
    render() {
        var classNameInputName = regularInputClass;
        var classNameSelect = regularSelectClass;

        return (
            <div>                
                <div className="uk-form-stacked uk-grid">

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-orderNo">Order No</label>
                        <div className="" style={style.inputStyle}>
                            <NumberInput className={classNameInputName} id="orderNroFrom" placeholder="0" type="Integer" value={this.state.criteria.orderNroFrom} onChange={this.handleUpdateOrderNroFrom.bind(this)} 
                                autoFocus={true} onKeyPress={this.handleKeyPress} />
                        </div>
                    </div>
                    
                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-CustomerIDName">Customer</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSearchSelect id="CustomerIDName2" placeholder="Customer" searchFunction={this.searchCustomer.bind(this)} getValue={this.handleUpdateCustomerIDName.bind(this)} 
                                data={this.state.criteria.customerList} objValue={{ value: this.state.criteria.CustomerID, name: this.state.criteria.CustomerIDName }} />
                        </div>
                    </div>

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-status">Status</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSelect className={classNameSelect} objValue={{ value: this.state.criteria.status }} getValue={this.handleUpdateStatus.bind(this)} 
                            placeholder={"Select an item..."} listHasPlaceholder={false} data={this.state.criteria.statusList} id="form-order-status" />
                        </div>
                    </div>
                    
                    {this.props.showLockedside && <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-lockedside">{"Buy / Sell"}</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSelect className={classNameSelect} objValue={{ value: this.state.criteria.lockedside }} getValue={this.handleUpdateLockedSide.bind(this)} 
                            placeholder={"Select an item..."} listHasPlaceholder={false} data={this.state.criteria.lockedsideList} id="form-order-lockedside" />
                        </div>
                    </div>}

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-valueDateFrom">Date From</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={this.state.criteria.valueDateFrom} onDayChange={this.handleUpdateValueDateFrom.bind(this)} />
                        </div>
                    </div>

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-valueDateTo">Date To</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={this.state.criteria.valueDateTo} onDayChange={this.handleUpdateValueDateTo.bind(this)} />
                        </div>
                    </div>

                    
                    <div className="uk-width-1-1">
                        <button className="uk-button uk-button-green" onClick={this.handleClearCriteriaClick.bind(this)}>Clear Fields</button>
                        <button className="uk-button uk-button-green" onClick={this.handleSearchCriteriaClick.bind(this)}>Search</button>
                    </div>

                </div>
            </div>
        );
    }

}